/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reader_MenuInputs */

const en_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reader Menu`)
};

const es_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú del lector`)
};

const fr_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu du lecteur`)
};

const de_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reader-Menü`)
};

const ja_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リーダーメニュー`)
};

const zh_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读器菜单`)
};

const ar_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة القارئ`)
};

const id_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu Pembaca`)
};

const it_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu Lettore`)
};

const ru_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню ридера`)
};

const pt_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu do Leitor`)
};

const ko_reader_menu = /** @type {(inputs: Reader_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리더 메뉴`)
};

/**
* | output |
* | --- |
* | "Reader Menu" |
*
* @param {Reader_MenuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reader_menu = /** @type {((inputs?: Reader_MenuInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reader_MenuInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reader_menu(inputs)
	if (locale === "es") return es_reader_menu(inputs)
	if (locale === "fr") return fr_reader_menu(inputs)
	if (locale === "de") return de_reader_menu(inputs)
	if (locale === "ja") return ja_reader_menu(inputs)
	if (locale === "zh") return zh_reader_menu(inputs)
	if (locale === "ar") return ar_reader_menu(inputs)
	if (locale === "id") return id_reader_menu(inputs)
	if (locale === "it") return it_reader_menu(inputs)
	if (locale === "ru") return ru_reader_menu(inputs)
	if (locale === "pt") return pt_reader_menu(inputs)
	return ko_reader_menu(inputs)
});